import React, { useState } from "react";

const SuccessMessageBox = ({ message }) => {
  const [visible, setVisible] = useState(true); // State to toggle visibility

  // Close the notification
  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null; // Hide component when not visible

  return (
    <div className="fixed inset-x-0 bottom-5 flex justify-center z-[110]">
      <div className="flex items-center bg-bg-hex text-white px-6 py-3 rounded-full shadow-lg">
        <span className="mr-3 text-lg">✔</span>
        <span className="mr-4">{message}</span>
        <button
          onClick={handleClose}
          className="text-lg font-bold hover:text-gray-100"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default SuccessMessageBox;
